import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractService } from '../commons/abstract.service';
import { Pager } from '../commons/pager';
import { WalletEntry } from '../models/wallet-entry.model';

/**
 * The consumption statement — SPEC-2026-08-typed-wallets RF-35.
 *
 * A separate service from WalletService purely so the inherited
 * `getAll(page, perPage, search, params)` — which hardcodes `{base}/pager` —
 * works unmodified with `Pager<T>` and the shared `<paginator>`.
 */
@Injectable({ providedIn: 'root' })
export class WalletEntryService extends AbstractService<WalletEntry> {

  getURLBase(): string {
    return '/wallet-entry';
  }

  constructor(http: HttpClient) {
    super(http);
  }

  preCreate(obj: WalletEntry): void { }

  preUpdate(obj: WalletEntry): void { }

  /** web-admin only; the server enforces `root`. */
  listAdmin(page: number, perPage: number, search: string, params: Record<string, any>): Observable<Pager<WalletEntry>> {
    return super.getWithParams('/admin/pager', { page, perPage, search: search ?? '', ...params });
  }
}
